<template>
  <div class="home">
    <!-- Desktop Layout -->
    <template v-if="width > 600">
      <div class="w3-row">
        <div class="w3-col l8 animateUp">
          <div class="sectionContainer">
            <div class="sectionHeader">
              <h5>Our Mission</h5>
            </div>
            <div class="whiteContainer homeContent">
              <p>Daytona Local provides a database of <router-link to="/events" tag="a">local events</router-link>, <router-link to="/attractions" tag="a">attractions</router-link>, <router-link to="/parks" tag="a">parks</router-link>, <router-link to="/dining" tag="a">dining</router-link> and things to do in Daytona Beach, Florida.</p>
              <p><router-link to="/organizers" tag="a">Event Organizers</router-link> and anyone with event information can post their events on the site for free and even get paid if an advertiser purchases a banner on the event page.</p>
              <p><router-link to="/advertisers" tag="a">Advertisers and Local Businesses</router-link> can select event pages to advertise on, for only $2 per day. Only pay for high quality, targeted local traffic based on interest.</p>
            </div>
          </div>

          <!-- News -->
          <template v-if="news.length > 0">
            <div class="sectionContainer">
              <div class="sectionHeader">
                <h5>Latest News</h5>
                <div class="w3-right">
                  <div class="viewAll">
                    <button class="w3-button" @click="viewAll('news')">View More News</button>
                  </div>
                </div>
              </div>
              <div class="w3-row">
                <div class="loaderContainer" v-if="loadingNews">
                  <div class="loader"></div>
                </div>
                <news layout="home"></news>
              </div>
            </div>
          </template>

          <!-- Upcoming Events -->
          <div class="sectionContainer">
            <div class="sectionHeader">
              <h5>Upcoming Events</h5>
              <div class="w3-right">
                <div class="viewAll">
                  <button class="w3-button" @click="viewAll('events')">View More Events</button>
                </div>
              </div>
            </div>
            <div class="w3-row">
              <div class="loaderContainer" v-if="loadingEvents">
                <div class="loader"></div>
              </div>
              <events type="upcoming" :date="false" :image="true" layout="home"></events>
            </div>
          </div>
          <!-- Attractions -->
          <div class="sectionHeader">
            <h5>Attractions</h5>
            <div class="w3-right">
              <div class="viewAll">
                <button class="w3-button" @click="viewAll('attractions')">View More Attractions</button>
              </div>
            </div>
          </div>
          <div class="w3-row">
            <attractions layout="home"></attractions>
          </div>

          <!-- Dining -->
          <div class="sectionHeader">
            <h5>Dining</h5>
            <div class="w3-right">
              <div class="viewAll">
                <button class="w3-button" @click="viewAll('dining')">View More Dining</button>
              </div>
            </div>
          </div>
          <div class="w3-row" >
            <dining layout="home"></dining>
          </div>
        </div>

        <!-- Sidebar -->
        <div class="w3-col l4 animateLeft">

          <!-- Ads -->
          <ads type="sidebar"></ads>
          
          <div class="sectionHeader">
            <h5>Share Daytona Local</h5>
          </div>
          <div class="whiteContainer" style="margin:0 4px 8px;">
            <div class="w3-row">
              <div class="w3-col s4 w3-center">
                <a class="w3-block w3-blue w3-padding" :href="share('fb')" aria-label="facebook share" target="_blank" rel="noreferrer">
                  <font-awesome-icon :icon="['fab', 'facebook-f']"></font-awesome-icon>
                </a>
              </div>
              <div class="w3-col s4 w3-center">
                <a class="w3-block w3-light-blue w3-padding" :href="share('tw')" aria-label="twitter share" target="_blank" rel="noreferrer">
                  <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
                </a>
              </div>
              <div class="w3-col s4 w3-center">
                <a class="w3-block w3-red w3-padding" :href="share('gp')" aria-label="google share" target="_blank" rel="noreferrer">
                  <font-awesome-icon :icon="['fab', 'google-plus']"></font-awesome-icon>
                </a>
              </div>
            </div>
          </div>

          <div v-if="events.past.length > 0">
            <div class="sectionHeader">
              <h5>Past Events</h5>
              <div class="w3-right">
                <div class="viewAll">
                  <button class="w3-button" @click="viewAll('events')">View More Events</button>
                </div>
              </div>
            </div>
            <events type="past" :image="true" layout="thin" :limit="6"></events>
          </div>
        </div>
      </div>
    </template>

    <!-- Mobile Layout -->
    <template v-if="width < 601">
      <!-- Quick Links -->
      <div class="sectionHeader w3-center">
        <h5>Quick Links</h5>
      </div>
      <div class="whiteContainer" style="margin:0 4px 8px;">
        <div class="w3-row w3-margin-bottom">
          <!-- <div class="w3-col s6">
            <div style="margin-right:4px;">
              <button @click="goto('news')" class="w3-button w3-block w3-green" style="border-right:1px solid #fafafa;">News</button>
            </div>
          </div> -->
          <div class="w3-col s6">
            <div style="margin-right:4px;">
              <button @click="goto('events')" class="w3-button w3-block w3-green" style="border-right:1px solid #fafafa;">Upcoming Events</button>
            </div>
          </div>
          <div class="w3-col s6">
            <div style="margin-left:4px;">
              <button @click="goto('events#past')" class="w3-button w3-block w3-purple" style="border-right:1px solid #fafafa;">Past Events</button>
            </div>
          </div>
        </div>
        <div class="w3-row w3-margin-bottom">
          <div class="w3-col s6">
            <div style="margin-right:4px;">
              <button @click="goto('attractions')" class="w3-button w3-block w3-blue" style="border-right:1px solid #fafafa;">Attractions</button>
            </div>
          </div>
          <div class="w3-col s6">
            <div style="margin-left:4px;">
              <button @click="goto('dining')" class="w3-button w3-block w3-dark-orange" style="border-right:1px solid #fafafa;">Dining</button>
            </div>
          </div>
        </div>
        <div class="w3-row">
          <div class="w3-col s6 w3-center">
            <div style="margin-right:4px;">
              <router-link to="/organizers" tag="button" class="w3-button w3-block w3-dark-cyan">Submit Event</router-link>
            </div>
          </div>
          <div class="w3-col s6 w3-center">
            <div style="margin-left:4px;">
              <router-link to="/advertisers" tag="button" class="w3-button w3-block w3-teal">Advertising</router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- Ads -->
      <div class="sectionHeader w3-center">
        <h5>Sponsored By</h5>
      </div>
      <ads type="mobile"></ads>

      <!-- Share -->
      <div class="sectionHeader w3-center">
        <h5>Share Daytona Local</h5>
      </div>
      <div class="whiteContainer" style="margin:0 4px 8px;">
        <div class="w3-row">
          <div class="w3-col s4 w3-center">
            <a class="w3-block w3-blue w3-padding" :href="share('fb')" aria-label="facebook share" target="_blank" rel="noreferrer">
              <font-awesome-icon :icon="['fab', 'facebook-f']"></font-awesome-icon>
            </a>
          </div>
          <div class="w3-col s4 w3-center">
            <a class="w3-block w3-light-blue w3-padding" :href="share('tw')" aria-label="twitter share" target="_blank" rel="noreferrer">
              <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
            </a>
          </div>
          <div class="w3-col s4 w3-center">
            <a class="w3-block w3-red w3-padding" :href="share('gp')" aria-label="google share" target="_blank" rel="noreferrer">
              <font-awesome-icon :icon="['fab', 'google-plus']"></font-awesome-icon>
            </a>
          </div>
        </div>
      </div>

      <!-- News -->
      <template v-if="news.length > 0">
        <div class="sectionContainer">
          <div class="sectionHeader">
            <h5>Latest News</h5>
            <div class="w3-right">
              <div class="viewAll">
                <button class="w3-button" @click="viewAll('news')">View More News</button>
              </div>
            </div>
          </div>
          <div class="w3-row">
            <div class="loaderContainer" v-if="loadingNews">
              <div class="loader"></div>
            </div>
            <news layout="home"></news>
          </div>
        </div>
      </template>

      <!-- Upcoming Events -->
      <div class="sectionContainer">
        <div class="sectionHeader">
          <h5>Upcoming Events</h5>
          <div class="w3-right">
            <div class="viewAll">
              <button class="w3-button" @click="viewAll('events')">View More Events</button>
            </div>
          </div>
        </div>
        <div class="w3-row">
          <div class="loaderContainer" v-if="loadingEvents">
            <div class="loader"></div>
          </div>
          <events type="upcoming" :date="false" :image="true" layout="home"></events>
        </div>
      </div>

      <!-- Past Events -->
      <div v-if="events.past.length > 0">
        <div class="sectionHeader">
          <h5>Past Events</h5>
          <div class="w3-right">
            <div class="viewAll">
              <button class="w3-button" @click="viewAll('events')">View More Events</button>
            </div>
          </div>
        </div>
        <events type="past" :image="true" layout="thin" :limit="3"></events>
      </div>

      <!-- Attractions -->
      <div class="sectionHeader">
        <h5>Attractions</h5>
        <div class="w3-right">
          <div class="viewAll">
            <button class="w3-button" @click="viewAll('attractions')">View More Attractions</button>
          </div>
        </div>
      </div>
      <div class="w3-row">
        <attractions layout="home"></attractions>
      </div>

      <!-- Dining -->
      <div class="sectionHeader">
        <h5>Dining</h5>
        <div class="w3-right">
          <div class="viewAll">
            <button class="w3-button" @click="viewAll('dining')">View More Dining</button>
          </div>
        </div>
      </div>
      <div class="w3-row" >
        <dining layout="home"></dining>
      </div>

      <div class="sectionContainer">
        <div class="sectionHeader">
          <h5>Welcome to DaytonaLocal.com</h5>
        </div>
        <div class="whiteContainer">
          <p>Daytona Local was built to help find <router-link to="/events" tag="a">local events</router-link>, <router-link to="/attractions" tag="a">attractions</router-link>, <router-link to="/dining" tag="a">dining</router-link> and things to do in Daytona Beach, Florida.</p>
          <p><router-link to="/organizers" tag="a">Event Organizers</router-link> and anyone with event information can post their events on the site for free. If an advertiser purchases a banner on the event page the user who submitted the event gets paid.</p>
          <p><router-link to="/advertisers" tag="a">Advertisers and Local Businesses</router-link> can select specific event pages to advertise on for as little as $2 to show a banner ad for a whole day. Easily sort and find just the events that matter to you and only pay for high quality, targeted local traffic.</p>
        </div>
      </div>

    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import news from '@/components/news.vue'
import events from '@/components/events.vue'
import attractions from '@/components/attractions.vue'
import dining from '@/components/dining.vue'
import moment from 'moment'

export default {
  name: 'home',
  metaInfo () {
    return {
      title: 'Daytona Local - Daytona Beach Local Events, Attractions and Dining Guide',
      description: 'Local Events, Attractions and Restaurants in Daytona Beach, FL. Post events and get paid when advertisers buy space on the page.',
      meta: [
        {name: 'title', content: 'Daytona Local - Daytona Beach Local Events, Attractions and Dining Guide'},
        {name: 'og:title', content: 'Daytona Local - Daytona Beach Local Events, Attractions and Dining Guide'},
        {property: 'og:site_name', content: 'Daytona Local'},
        {property: 'og:type', content: 'website'},
        {name: 'og:image', content: 'https://server.daytonalocal.com/static/card.jpg'}
      ]
    }
  },
  data() {
    return {
      featuredEvents: [],
      hasUpcoming: false,
      hasPast: false,
      members: [],
      slideIndex: 0,
      width: window.innerWidth
    }
  },
  computed: mapState([
    'events',
    'news',
    'allAttractions',
    'allRestaurants',
    'loadingEvents',
    'loadingNews'
  ]),
  mounted() {
    this.$store.dispatch('getNews')
    this.$store.dispatch('getEvents')
  },
  components: {
    news,
    events,
    attractions,
    dining
  },
  methods: {
    slide(event, direction) {
      if (direction === 'up') {
        this.$refs[event.eventid][0].children[1].style.top = '0'
      } else if (direction === 'down') {
        this.$refs[event.eventid][0].children[1].style.top = '150px'
      }
    },
    eventNav(event) {
      this.$router.push({ name: 'event-details', params: {event: event} })
      window.scrollTo(0, 0)
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    goto(place) {
      this.$router.push(place)
      window.scrollTo(0, 0)
    },
    viewAll(name) {
      this.$router.push({ name: name })
      window.scrollTo(0, 0)
    },
    share(type) {
      let sharePage = ""
      if (type === 'fb') {
        sharePage = encodeURI("https://www.facebook.com/sharer.php?u=https://daytonalocal.com/")
      } else if (type === 'tw') {
        sharePage = encodeURI("https://twitter.com/intent/tweet?url=https://daytonalocal.com/")
      } else if (type === 'gp') {
        sharePage = encodeURI("https://plus.google.com/share?url=https://daytonalocal.com/")
      } else {
        // nothing
      }
      return sharePage
    }
  }
}
</script>

<style scoped>
.desc {padding-left:5px}
.card .desc {padding:0;}
.title {font-size:14px; margin:0; padding:0 5px;}
.eventDate {padding-left:5px;}

.homeContent a {font-weight: 700;}
</style>
